import { GetStaticPaths, GetStaticPropsContext, NextPage } from 'next'
import { useTranslation } from 'next-i18next'

import Metatags from '~/components/Metadata/Metatags'

import { DEFAULT_LAYOUT_TRANSLATION_MODULE_NAMES } from '~/shared/layouts/constants'

import { AppLanguage } from '~/types/locale'
import { usePageTitle } from '~/utils/tags'

import { DefaultLayout } from '~/shared/layouts'

import { Team } from '~/employee/pages/Team.page'

import { setEmployeeFieldsActionCreator } from '~/employee/slices/employee.slice'
import { AppStore } from '~/redux/store'

import { getAllEmployeeData, getEmployeeCategories } from '~/../utils/data-fetch/employee/employee.query'

import { getStaticPropsWrapper } from '~/utils/pageWrapper/staticPageWrapper'
import { GetProps } from '~/utils/pageWrapper/types'
import { Employee, EmployeeCategory } from '~/employee/types/employee.types'

const OurTeam: NextPage = () => {
  const { t } = useTranslation('ourTeam')

  return (
    <>
      <Metatags metaDescription={t('metaDescription')} title={usePageTitle(t('title'))} />

      <DefaultLayout zeroPadding>
        <Team />
      </DefaultLayout>
    </>
  )
}

export const getStaticPaths: GetStaticPaths = () => {
  return {
    paths: [],
    fallback: 'blocking',
  }
}

export const getProps: GetProps =
  (store: AppStore) =>
  async ({ locale, params }: GetStaticPropsContext<{ locale: AppLanguage; employeeType: string; page: string }>) => {
    const [employeeSanityData, employeeCategoriesSanityData] = await Promise.all([
      getAllEmployeeData(locale as AppLanguage),
      getEmployeeCategories(locale as AppLanguage),
    ])

    store.dispatch(
      setEmployeeFieldsActionCreator({
        employees: employeeSanityData as Employee[],
        categories: employeeCategoriesSanityData as EmployeeCategory[],
      }),
    )

    return {
      props: {
        path: `/our-team/${params?.employeeType}/${params?.page}`,
        namespaces: [...DEFAULT_LAYOUT_TRANSLATION_MODULE_NAMES, 'ourTeam', 'notFound'],
      },
      revalidate: process.env.NEXT_PUBLIC_ENVIRONMENT === 'staging' ? 60 : false,
    }
  }

export const getStaticProps = getStaticPropsWrapper(getProps)

export default OurTeam
